<template>
    
      <div>
        <div>
            <img src="img/suggestions.webp" width="100%"  />
        </div>
        <p></p>
        <div>
            
            <b-form-input
            id="suggestion_name"
            v-model="suggestion_name"
            placeholder="Se desejar, diga-nos seu nome..."
            ></b-form-input>

            <b-form-textarea
            id="suggestion_content"
            v-model="suggestion_content"
            placeholder="Envie-nos a sua sugestão..."
            rows="3"            
            ></b-form-textarea>

           
        </div>
        
        <div><b-button type="submit" size="sm" variant="primary" @click="submitSuggestion()"><i class="fa fa-mixcloud"></i> Enviar Sugestão</b-button></div>
      </div>
      
    
</template>

<script>
import axios from "axios";
import Vue from 'vue'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)

export default {
    name: 'componentSuggestion',
    data: function() {
        return {
          suggestion_name: '',
          suggestion_content: ''
        }
    },

    methods: {
      async saveSuggestion(currentUser) {
        var s = this
        await axios.post(
            this.$store.state.ws_url + "/hr/suggestion",
            {
              "userid": currentUser.id > 0 ? currentUser.id : null,
              "suggestion": this.suggestion_content,
              "name": this.suggestion_name,
              "currentUserId": currentUser.id > 0 ? currentUser.id : 1,
              "currentUserSid": ''
            }
        ).then(function(resp) {

        }).catch(function (error) {
          console.log(error);
        });

        this.suggestion_content = ""
        this.suggestion_name = ""

      },


        submitSuggestion() {

          if(this.suggestion_content != "") {

            if(this.suggestion_content.length < 20) {
              toast ({
                type: VueNotifications.types.error,
                title: 'Sugestão',
                message: 'Tem certeza de que conseguiu se expressar com apenas 20 caracteres???',
                timeout: 2000
              });
            }
            else {
              
              this.saveSuggestion(this.$store.state.currentUser);
              toast ({
                type: VueNotifications.types.info,
                title: 'Sugestão',
                message: 'Obrigado pela sugestão, vamos analisar com carinho seu comentário.',
                timeout: 2000
              });
            }

          }
          else {
            toast ({
              type: VueNotifications.types.error,
              title: 'Sugestão',
              message: 'Por favor, preencha o campo com a sua sugestão. Ela é muito importante para nós. Se preferir, identifique-se para que possamos entrar em contato. Quem sabe ganhar um Prêmio Especial !?.',
              timeout: 10000
            });
          }

          
        }
    }
}
</script>
